module.exports = __webpack_public_path__ + "static/media/english_reel.9a39beb6.mp4";